<template>
  <div class="container-fluid min-vh-100">
    <div class="row d-flex justify-content-center align-items-center min-vh-100">
      <div class="col-12 col-sm-6 col-lg-5 col-xl-3 bg-white">
        <div class="text-center mb-4">
          <img class="w-50" src="../../assets/img/rm-logo.svg" alt="RestMonster logotype">
        </div>
        <form>
          <div v-if="!codesent">
            <h4 class="text-center mt-2 mb-3">{{ $t('auth.btn.forgotPassword') }}</h4>
            <p class="text-left mt-2 mb-2">{{ $t('auth.forgotPasswordTextEmail') }}</p>
            <label for="userEmail" class="form-label small text-muted">{{ $t('auth.email') }}</label>
            <input v-model.trim="user.email" type="email" class="form-control" id="userEmail"
              :class="v$.user.email.$error ? 'border-danger' : ''">
            <div class="pt-2 mt-3 d-block text-center">
              <button 
                block
                :loader="loader"
                @click.once="onFind()"
                type="button" class="btn btn-outline-dark"
                :disabled="v$.user.email.$invalid || this.emailSent"
                :class="loader ? 'disable' : '' ">
                <span v-show="loader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ $t('auth.btn.sendCode') }}
              </button>
            </div>
          </div>
          <div v-else>
            <div v-if="passwordChange">
              <h4 class="text-center mt-2 mb-3">{{ $t('auth.forgotPasswordPassChangeHeader') }}</h4>
              <p class="text-left mb-2 mb-2">{{ $t('auth.forgotPasswordTextCode') }}</p>            
              <input
                label="Confirmation Code"
                type="text" class="form-control"
                v-model="code"
                required>
              <p class="text-left mt-3 mb-2">{{ $t('auth.forgotPasswordTextNewPassword') }}</p>            
              <input
                autocomplete="new-password"
                class="form-control"
                label="New Password"
                v-model="user.password"
                :append-icon="hidepw ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (hidepw = !hidepw)"
                :type="hidepw ? 'password' : 'text'">
              <div class="small text-muted">{{$t('auth.passwordDescription')}}</div>
              <div class="pt-2 mt-3 d-block text-center">
                <button 
                  block
                  :loader="loader"
                  @click="onSubmit()"
                  type="button" class="btn btn-outline-dark"
                  :disabled="v$.user.password.$invalid || v$.code.$invalid || loader">
                  <span v-show="loader" class="spinner-border spinner-border-sm" role="status"></span>
                  {{ $t('auth.btn.confirmPassword') }}
                </button>
              </div>
            </div>
            <div v-else>
              <p class="text-center mt-2 mb-2">Ваш пароль успешно изменен!</p>
              <div class="mt-3 pt-2 d-block text-center">
                <router-link to="/" tag="button" type="button" class="btn btn-outline-dark">
                {{ $t('auth.followHome') }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="mt-3 mb-3 d-block d-flex justify-content-end">
            <router-link to="/" class="link-dark">{{ $t('auth.followHome') }}</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const config = require('@/config');
import i18n from "@/i18n";
import { useVuelidate } from '@vuelidate/core';
import { required, email, minLength, helpers } from '@vuelidate/validators';
import { vMaska } from "maska";
const reqPassword = helpers.regex(/(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,}/g);
var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
var userPool = [];
userPool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData);
var userData = {
  Username: '',
  Pool: userPool
};

export default {
  directives: { maska: vMaska },
  name: "ForgotPassword",
  setup () {
    return { v$: useVuelidate({ $autoDirty: true}) }
  },
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      codesent: false,
      errcode: '',
      errmsg: '',
      code: '',
      hidepw: true,
      loader: false,
      passwordChange: true,
      emailSent: false,
    }
  },
  validations() {
    return {
      user: {
        email: { required, email },
        password: { 
          required, 
          minLength: minLength(9), 
          validateFormats: reqPassword,
        },
      },
      code: { required },
    }
  },
  methods: {
    onCommon() {
      this.loader = true
      userData.Username = this.user.email
      this.errcode = ''
    },
    onSubmit() {
      this.onCommon()
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData)
      cognitoUser.confirmPassword(this.code, this.user.password, {
        onSuccess: () => {
          this.loader = false
          this.passwordChange = !this.passwordChange
        },
        onFailure: (err) => {
          var code = JSON.stringify(err.code)
          this.errcode = code
          this.loader = false
        }
      })
    },
    onFind () {
      this.onCommon()
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData)
      cognitoUser.forgotPassword({
        onSuccess: () => {
          this.loader = false
        },
        onFailure: (err) => {
          var code = JSON.stringify(err.code)
          this.errcode = code
          this.loader = false
        },
        inputVerificationCode: (data) => {
          var result = JSON.stringify(data)
          console.log('Code sent to: ' + result)
          this.codesent = true
          this.loader = false
        }
      })
      this.emailSent = true
    },
  },  
  watch: {
    errcode () {
        if (this.errcode !== '') {
          if (this.errcode === '"CodeMismatchException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.CodeMismatchException'), error: true})
        } else if (this.errcode === '"NotAuthorizedException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.NotAuthorizedException'), error: true})
        } else if (this.errcode === '"UserNotFoundException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.UserNotFoundException'), error: true})
        } else if (this.errcode === '"LimitExceededException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.LimitExceededException'), error: true})
        } else if (this.errcode === '"UserNotConfirmedException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.UserNotConfirmedException'), error: true})
        } else {
          this.$store.dispatch('addNewNotice', {text: this.errcode, error: true})
        }
      }
      this.loader = false
    }
  }
}
</script>

<style scoped>

</style>
